import HttpRequest from '@/libs/axios'
import config from '@/config'
// const currentEnv = process.env.NODE_ENV
// const baseUrl =
//   currentEnv === 'development'
//     ? config.baseUrl.dev
//     : currentEnv === 'test'
//       ? config.baseUrl.test
//       : config.baseUrl.pro
import { env } from '../../config/processEnv';
const baseUrl = env == 'dev'? config.baseUrl.dev : env == 'test' ? config.baseUrl.test : env == 'pre-prod' ? config.baseUrl.preProd : config.baseUrl.prod;



const axios = new HttpRequest(baseUrl)
export default axios



// WEBPACK FOOTER //
// ./src/libs/api.request.js